/**
 * Порции «показать ещё» для длинных списков (правило владельца «второстепенное — порциями»):
 * фразы в листе словаря — 6 строк и «ещё» по 10, в записи генерации — переводы по 3,
 * элементы по 6, пропуски по 3. Чистая функция без alias-импортов: её собирают тесты.
 */
export interface PageWindow {
  /** Сколько строк видно в свёрнутом виде. */
  base: number;
  /** Сколько строк добавляет «ещё»; `Infinity` — показать всё остальное разом. */
  step: number;
}

export interface Paged<T> {
  visible: T[];
  /** Сколько строк добавит «ещё N»; 0 — кнопки нет. */
  more: number;
  /** Лимит после нажатия «ещё». */
  next: number;
  /** Открыто больше свёрнутого вида — нужна «свернуть». */
  canCollapse: boolean;
}

/**
 * `limit` — сколько строк открыто сейчас (начинается с `win.base`). `keep` — строки, которые
 * не прячем никогда: раскрытая или с отмеченным значением.
 */
export function pageList<T>(
  list: readonly T[],
  limit: number,
  win: PageWindow,
  keep?: (item: T, index: number) => boolean,
): Paged<T> {
  const visible = list.filter((item, index) => index < limit || (keep ? keep(item, index) : false));
  return {
    visible,
    more: Math.min(win.step, list.length - visible.length),
    next: limit + win.step,
    canCollapse: limit > win.base,
  };
}
